(function () {
'use strict';
var MOBILE_MAX = 749;
function isMobile() {
return window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches;
}
function ready(fn) {
if (document.readyState !== 'loading') fn();
else document.addEventListener('DOMContentLoaded', fn);
}
ready(function () {
var dataEl = document.getElementById('bl-mobile-nav-data');
if (!dataEl) return;
var data;
try {
data = JSON.parse(dataEl.textContent);
} catch (e) {
return;
}
if (!data || !Array.isArray(data.items)) return;
var byHandle = {};
data.items.forEach(function (item) {
if (item && item.handle) byHandle[item.handle] = item;
});
var row = document.querySelector('.header__navigation-bar-row');
if (!row) return;
var strip = row.querySelector('.menu-list--mobile');
if (!strip) return;
var panel = document.createElement('div');
panel.className = 'bl-navpanel';
panel.setAttribute('hidden', '');
row.appendChild(panel);
var openHandle = null;
function setChipState(handle, expanded) {
var chip = strip.querySelector('[data-bl-toggle="' + handle + '"]');
if (chip) chip.setAttribute('aria-expanded', expanded ? 'true' : 'false');
}
function closePanel() {
panel.setAttribute('hidden', '');
panel.innerHTML = '';
if (openHandle) setChipState(openHandle, false);
openHandle = null;
}
function makeLi(node) {
var li = document.createElement('li');
var a = document.createElement('a');
a.href = node.url;
a.textContent = node.title;
a.className = 'bl-navpanel__link';
li.appendChild(a);
return li;
}
function buildPanel(item) {
var frag = document.createDocumentFragment();
if (item.url) {
var all = document.createElement('a');
all.className = 'bl-navpanel__all';
all.href = item.url;
all.textContent = 'View all ' + item.title;
frag.appendChild(all);
}
(item.children || []).forEach(function (child) {
if (child.children && child.children.length) {
var group = document.createElement('div');
group.className = 'bl-navpanel__group';
var head = document.createElement('a');
head.className = 'bl-navpanel__heading';
head.href = child.url;
head.textContent = child.title;
group.appendChild(head);
var ul = document.createElement('ul');
ul.className = 'bl-navpanel__list';
child.children.forEach(function (gc) {
ul.appendChild(makeLi(gc));
});
group.appendChild(ul);
frag.appendChild(group);
} else {
var soloUl = document.createElement('ul');
soloUl.className = 'bl-navpanel__list';
soloUl.appendChild(makeLi(child));
frag.appendChild(soloUl);
}
});
return frag;
}
function openPanel(handle, item) {
if (openHandle && openHandle !== handle) setChipState(openHandle, false);
panel.innerHTML = '';
panel.appendChild(buildPanel(item));
panel.removeAttribute('hidden');
setChipState(handle, true);
openHandle = handle;
}
var chips = strip.querySelectorAll('.menu-list__item');
Array.prototype.forEach.call(chips, function (chip) {
var id = chip.id || '';
var prefix = 'MenuItem-';
var handle = id.indexOf(prefix) === 0 ? id.slice(prefix.length) : null;
if (!handle) return;
var item = byHandle[handle];
if (!item || !item.children || !item.children.length) return;
chip.setAttribute('data-bl-toggle', handle);
chip.setAttribute('aria-haspopup', 'true');
chip.setAttribute('aria-expanded', 'false');
chip.classList.add('menu-list__item--has-panel');
chip.addEventListener('click', function (e) {
if (!isMobile()) return;
e.preventDefault();
e.stopPropagation();
if (openHandle === handle) {
closePanel();
} else {
openPanel(handle, item);
}
});
});
document.addEventListener('click', function (e) {
if (!openHandle) return;
if (panel.contains(e.target)) return;
if (e.target.closest && e.target.closest('[data-bl-toggle]')) return;
closePanel();
});
panel.addEventListener('click', function (e) {
if (e.target.closest && e.target.closest('a')) closePanel();
});
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape') closePanel();
});
var desktopMq = window.matchMedia('(min-width: ' + (MOBILE_MAX + 1) + 'px)');
var onMqChange = function (e) {
if (e.matches) closePanel();
};
if (desktopMq.addEventListener) desktopMq.addEventListener('change', onMqChange);
else if (desktopMq.addListener) desktopMq.addListener(onMqChange);
var drawer = document.getElementById('Details-menu-drawer-container');
if (drawer) {
drawer.addEventListener('toggle', function () {
if (drawer.open) closePanel();
});
}
});
})();